import { useState } from "react";
import { FiSearch, FiMenu, FiX } from "react-icons/fi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../image/logo.png"


function Header({ setSearch }) {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate()
    const location = useLocation();

    const navLinks = [
        { name: "Technology", href: "technology" },
        { name: "Innovation", href: "innovation" },
        { name: "Guides", href: "guides" },
    ];

    const handleSearch = (value) => {
        setSearch(value);

        // current category (innovation / guides / technology)
        const path = location.pathname === "/" ? "/innovation" : location.pathname;

        navigate(`${path}?q=${encodeURIComponent(value)}`);
    };

    return (
        <header className="w-full bg-[#FFFAEC] sticky top-0 z-10">
            <div className="max-w-7xl mx-auto px-4">
                <div className="flex items-center justify-between">

                    {/* LOGO */}
                    <Link to="/"><div className="flex items-center gap-1">
                        <img src={logo} alt="Recommand Jobs Logo" className="w-40 h-20" width="160" height="80" />
                    </div>
                    </Link>
                    {/* SEARCH */}
                    <div className="flex items-center gap-4">
                        {/* DESKTOP NAV */}
                        <nav className="hidden md:flex items-center gap-8">
                            {navLinks.map((link) => (
                                <Link
                                    key={link.name}
                                    to={`/${link.href}`}

                                    className="text-secondary font-medium hover:text-primary transition"
                                >
                                    {link.name}
                                </Link>
                            ))}
                        </nav>
                        <div className="hidden md:flex items-center">
                            <div className="relative">
                                <input
                                    type="text"
                                    placeholder="Search"
                                    onChange={(e) => handleSearch(e.target.value)}
                                    className="border border-gray rounded-md px-4 py-2 pr-10 focus:outline-none focus:ring-2 focus:ring-secondary"
                                />
                                <button aria-label="Search" className="absolute right-0 top-0 h-full px-3 bg-orange text-white rounded-r-md hover:bg-orange/50 transition">
                                    <FiSearch size={18} />
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* MOBILE MENU BUTTON */}
                    <button
                        className="md:hidden text-primary"
                        onClick={() => setOpen(!open)}
                        aria-label="Toggle menu"
                    >
                        {open ? <FiX size={24} /> : <FiMenu size={24} />}
                    </button>
                </div>
            </div>

            {/* MOBILE MENU */}
            {open && (
                <div className="md:hidden  bg-[#FFFAEC]">
                    <nav className="flex flex-col px-4 py-4 gap-4">
                        {navLinks.map((link) => (
                            <Link
                                key={link.name}
                                to={link.href}

                                className="text-secondary font-medium hover:text-primary"
                            >
                                {link.name}
                            </Link>
                        ))}

                        {/* MOBILE SEARCH */}
                        <div className="relative mt-2">
                            <input
                                type="text"
                                placeholder="Search"
                                onChange={(e) => handleSearch(e.target.value)}
                                className="w-full border border-gray rounded-md px-4 py-2 pr-10 focus:outline-none focus:ring-2 focus:ring-primary"
                            />
                            <button aria-label="Search" className="absolute right-0 top-0 h-full px-3 bg-orange text-white rounded-r-md">
                                <FiSearch size={18} />
                            </button>
                        </div>
                    </nav>
                </div>
            )}
        </header>
    );
}

export default Header;